import type { LandingContent } from "./types";

export const landingContent: LandingContent = {
  title: "Verderem",
  tagline: "A tabletop campaign, run by a rules engine that never forgets.",
  intro:
    "Verderem narrates your adventure while a deterministic rules engine handles the dice, the conditions, and the bookkeeping — so every roll is fair and every fact stays consistent.",
  heroImageAlt:
    "A Verderem campaign session, showing narrated scene text in the app interface",
  teaserHeading: "What you can do",
  teaserItems: [
    {
      title: "Build a character",
      description:
        "A guided creation flow walks through race, class, background, spells, and starting equipment — every choice validated against the rules as you go.",
      href: "/features",
    },
    {
      title: "Fight by the rules",
      description:
        "Attack rolls, saves, conditions, and damage resolve on a deterministic rules engine — the same way, every time, with nothing hidden from you.",
      href: "/features",
    },
    {
      title: "A session that remembers",
      description:
        "Every scene is narrated in the moment, grounded in what's actually true in your campaign so far — no contradictions, no forgotten details.",
      href: "/features",
    },
  ],
  metaTitle:
    "Verderem — A tabletop campaign, run by a rules engine that never forgets",
  metaDescription:
    "Verderem narrates your adventure while a deterministic rules engine handles the dice, the conditions, and the bookkeeping.",
};
